import { DISPATCH_ID } from '../../libs/utils/Const';

export const RenderReducer = (state = { renderToPrint: false, renderRelationShip: false, }, action) => {
    switch (action.type) {
        case DISPATCH_ID.RENDER_PRINT_TO_DOCUMENTS_MODAL:
            return Object.assign({}, state, { renderToPrint: action.value });
        default:
            return state;
    }
};